import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Download, Lock, ShieldCheck } from 'lucide-react';
import { Button } from './ui/Button';
export function Offer() {
  return <section id="oferta" className="py-24 bg-brand-cream px-6" data-id="element-153">
      <div className="max-w-4xl mx-auto" data-id="element-154">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-155">
          <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-156">
            Recupera la paz de tu familia hoy
          </h2>
          <p className="text-xl text-brand-navy/80 max-w-2xl mx-auto leading-relaxed" data-id="element-157">
            Recuperar la paz de tu familia y la confianza en tu maternidad
            cuesta menos que un combo de comida rápida.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-white rounded-3xl shadow-xl p-8 md:p-12 border border-brand-sage/20 relative overflow-hidden" data-id="element-158">
          <div className="absolute top-0 right-0 w-64 h-64 bg-brand-sage-light rounded-full blur-3xl opacity-50 -translate-y-1/2 translate-x-1/2" data-id="element-159"></div>

          <div className="grid md:grid-cols-2 gap-12 items-center relative z-10" data-id="element-160">
            <div className="order-2 md:order-1" data-id="element-161">
              <h3 className="font-serif text-2xl font-bold mb-6" data-id="element-162">
                El Método de los 90 Segundos
              </h3>

              <ul className="space-y-4 mb-8" data-id="element-163">
                {['El Manual del Botón de Pánico', 'La Brújula de Disparadores', 'Guiones de Supervivencia Social', 'Tu Escudo de Calma'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-164">
                    <CheckCircle2 className="text-brand-sage shrink-0" size={20} data-id="element-165" />
                    <span className="font-medium text-brand-navy/90" data-id="element-166">
                      {item}
                    </span>
                  </li>)}
              </ul>

              <div id="precio" className="mb-8 scroll-mt-24" data-id="element-167">
                <div className="text-brand-navy/50 line-through text-lg mb-1" data-id="element-168">
                  Valor normal: $29.00 USD
                </div>
                <div className="text-5xl font-bold text-brand-navy flex items-baseline gap-2" data-id="element-169">
                  $6,36{' '}
                  <span className="text-xl font-medium text-brand-navy/60" data-id="element-170">
                    USD
                  </span>
                </div>
              </div>

              <Button href="https://90seg.ofertavital.com/cart/439328882033291:1" target="_blank" rel="noopener noreferrer" className="w-full py-4 text-xl shadow-lg shadow-brand-sage/30 flex-col gap-1" data-id="element-171">
                <span data-id="element-172">Comprar Ahora</span>
                <span className="text-base font-medium opacity-90" data-id="element-173">$6,36</span>
              </Button>

              <div className="flex justify-center items-center gap-6 mt-6 text-brand-navy/60 text-sm" data-id="element-174">
                <div className="flex flex-col items-center gap-1" data-id="element-175">
                  <Lock size={20} data-id="element-176" />
                  <span data-id="element-177">Pago seguro</span>
                </div>
              </div>
            </div>

            <div className="order-1 md:order-2 flex justify-center" data-id="element-178">
              <img src="https://cdn.magicpatterns.com/uploads/u5mGtAYH298GEYikzXKcdP/PORTADA_METODO_90_SEGUNDOS_ULTIMA.png" alt="Libro El Método de los 90 Segundos" className="w-full max-w-sm rounded-xl shadow-2xl" data-id="element-179" />
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}